import { render, staticRenderFns } from "./sizeDialog.vue?vue&type=template&id=57ff6f6c&scoped=true"
import script from "./sizeDialog.vue?vue&type=script&lang=js"
export * from "./sizeDialog.vue?vue&type=script&lang=js"
import style0 from "./sizeDialog.vue?vue&type=style&index=0&id=57ff6f6c&prod&lang=scss&scoped=true"
import style1 from "./sizeDialog.vue?vue&type=style&index=1&id=57ff6f6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff6f6c",
  null
  
)

export default component.exports